import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContactsGroupsComponent } from './components/contacts-groups/contacts-groups.component';
import { ContactsComponent } from './components/contacts/contacts.component';
import { CreateContactGroupComponent } from './components/create-contact-group/create-contact-group.component';
import { CreateContactComponent } from './components/create-contact/create-contact.component';
import { CreateEventComponent } from './components/create-event/create-event.component';
import { CreateGroupComponent } from './components/create-group/create-group.component';
import { CreateTemplateComponent } from './components/create-template/create-template.component';
import { EmailTemplatesComponent } from './components/email-templates/email-templates.component';
import { EventsComponent } from './components/events/events.component';
import { GroupsComponent } from './components/groups/groups.component';
import { MessagesLogComponent } from './components/messages-log/messages-log.component';

const routes: Routes = [
  {
    path:'groups',
    children:[
      {
        path:'',
        component:GroupsComponent
      },
      {
        path:'create-group',
        component:CreateGroupComponent
      },
      {
        path:'edit/:id',
        component:CreateGroupComponent
      },
    ]
    
  },
  {
    path:'templates',
    children:[
      {
        path:'',
        component:EmailTemplatesComponent
      },
      {
        path:'create-template',
        component:CreateTemplateComponent
      },
      {
        path:'edit/:id',
        component:CreateTemplateComponent
      }
    ]
  },
  {
    path:'events',
    children:[
      {
        path:'',
        component:EventsComponent
      },
      {
        path:'create-event',
        component:CreateEventComponent
      }
    ]
  },
  {
    path:'outgoing-message-log',
    component:MessagesLogComponent
  },
  {
    path:'contacts',
    children:[
      {
        path:'',
        component:ContactsComponent
      },
      {
        path:'create-contact',
        component:CreateContactComponent
      },
      {
        path:'edit/:id',
        component:CreateContactComponent
      },
    ]
  },
  {
    path:'contacts-groups',
    children:[
        {
        path :'',
        component:ContactsGroupsComponent
        },
        {
          path:'create-contact-group',
          component:CreateContactGroupComponent
        },
        {
          path:'edit/:id',
          component:CreateContactGroupComponent
        },
      
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NotificationRoutingModule { }
